export default __webpack_public_path__ + "static/media/flag-greece.a73a3a8a.svg";